import {
  JOIN_SOCKET_CHANNEL,
  LEAVE_SOCKET_CHANNEL,
  SEND_SOCKET_EVENT,
  SET_SOCKETS_CONNECTED,
  SET_SOCKETS_DISCONNECTED,
  CHECK_AUTHORIZATION
} from 'constants';

export const joinSocketChannel = channel => ({
  type: JOIN_SOCKET_CHANNEL,
  payload : { channel }
});

export const leaveSocketChannel = channel => ({
  type: LEAVE_SOCKET_CHANNEL,
  payload : { channel }
});

// payload is the data we wish to send, we'll always fire "SEND_SOCKET_EVENT";
export const sendSocketEmit = (data, event) => ({
  type: SEND_SOCKET_EVENT,
  payload: { data, event }
});

export const setSocketsConnected = f =>({type:SET_SOCKETS_CONNECTED})
export const setSocketsDisconnected = f =>({type:SET_SOCKETS_DISCONNECTED})



// WEBPACK FOOTER //
// ./src/common/actions/socket.js